import { render } from "./QuestionFeedback.vue?vue&type=template&id=29c11834&scoped=true"
import script from "./QuestionFeedback.vue?vue&type=script&lang=js"
export * from "./QuestionFeedback.vue?vue&type=script&lang=js"

import "./QuestionFeedback.vue?vue&type=style&index=0&id=29c11834&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c11834"]])

export default __exports__